const tradesData = [
  {
    tradeSlug: "painters",
    pageTitle: "Estimate Software for Painters: SwiftBidPro - Quote Faster",
    metaDescription: "SwiftBidPro is the best painting estimate software for painters. Create fast, accurate quotes from your phone with templates designed for paint jobs. Try for free!",
    h1Heading: "The Best Estimate Software for Painters",
    introParagraph: "SwiftBidPro helps painters create professional quotes in minutes. Whether you're estimating interior painting, exterior jobs, or specialty finishes, our app streamlines your pricing with customizable templates. Standardize costs per square foot, account for materials, and send branded quotes directly from your phone — before you leave the job site.",
    tradeSpecificFeatures: [
      {
        title: "Paint Job Templates",
        description: "Pre-built templates for common painting projects — interior, exterior, commercial — with line items for surface prep, primer, and finishes."
      },
      {
        title: "Square Footage Calculator",
        description: "Enter wall or ceiling dimensions to instantly calculate paint quantities and labor costs based on your rates."
      },
      {
        title: "Material Cost Database",
        description: "Integrate your pricing for paint brands, primers, and supplies to ensure accurate material estimates every time."
      },
      {
        title: "Branded Paint Quotes",
        description: "Send professional, branded quotes with a secure link for clients to view and accept online, building trust in your painting business."
      }
    ],
    primaryKeyword: "painting estimate software",
    secondaryKeywords: ["painter quoting app", "paint job estimate template"],
    imagePath: "https://placehold.co/600x400/2563EB/FFFFFF?text=Painting+Estimate+Software&font=Inter"
  },
  {
    tradeSlug: "roofers",
    pageTitle: "Estimate Software for Roofers: SwiftBidPro - Quote Faster",
    metaDescription: "SwiftBidPro is top roofing estimate software for roofers. Build accurate quotes fast with templates for shingle, metal, or flat roofs. Try for free!",
    h1Heading: "The Best Estimate Software for Roofers",
    introParagraph: "SwiftBidPro empowers roofers to generate detailed quotes in minutes. From asphalt shingles to metal roofing or complex flat roof systems, our app simplifies estimates with tailored templates. Calculate square footage, material costs, and labor instantly, then send professional proposals from your phone — right after inspecting the roof.",
    tradeSpecificFeatures: [
      {
        title: "Roofing Project Templates",
        description: "Ready-to-use templates for common roofing jobs — replacements, repairs, or new installations — with line items for materials and labor."
      },
      {
        title: "Roof Area Calculations",
        description: "Input measurements to calculate square footage, pitch adjustments, and material needs like shingles, underlayment, and flashing."
      },
      {
        title: "Weatherproof Pricing",
        description: "Account for seasonal or weather-related costs with customizable add-ons to ensure your bids cover all variables."
      },
      {
        title: "Professional Roofing Bids",
        description: "Deliver clean, branded quotes with online viewing and acceptance options, helping your roofing business stand out."
      }
    ],
    primaryKeyword: "roofing estimate software",
    secondaryKeywords: ["roofer quoting app", "roofing proposal software"],
    imagePath: "https://placehold.co/600x400/2563EB/FFFFFF?text=Roofing+Estimate+Software&font=Inter"
  },
  {
    tradeSlug: "drywallers",
    pageTitle: "Estimate Software for Drywallers: SwiftBidPro - Quote Faster",
    metaDescription: "SwiftBidPro offers powerful drywall estimate software for drywall contractors. Create precise quotes fast with templates for drywall jobs. Try for free!",
    h1Heading: "The Best Estimate Software for Drywallers",
    introParagraph: "SwiftBidPro makes quoting drywall jobs quick and accurate. Whether it's new construction, renovations, or repairs, our app provides templates to estimate sheetrock, taping, and finishing costs. Input measurements for instant calculations and send professional quotes from your phone — right from the job site.",
    tradeSpecificFeatures: [
      {
        title: "Drywall Job Templates",
        description: "Custom templates for drywall installation, repair, and finishing, including line items for sheets, mud, tape, and labor."
      },
      {
        title: "Wall & Ceiling Calculator",
        description: "Enter dimensions to calculate drywall sheets needed, joint compound, and labor hours based on your pricing structure."
      },
      {
        title: "Finishing Level Options",
        description: "Adjust estimates for different finishing levels (Level 1-5) to provide accurate costs for client specifications."
      },
      {
        title: "Branded Drywall Quotes",
        description: "Send polished, branded quotes with secure online access for clients to review and accept, enhancing your professional image."
      }
    ],
    primaryKeyword: "drywall estimate software",
    secondaryKeywords: ["drywall estimating app", "drywall bid calculator"],
    imagePath: "https://placehold.co/600x400/2563EB/FFFFFF?text=Drywall+Estimate+Software&font=Inter"
  },
  {
    tradeSlug: "general-contractors",
    pageTitle: "Estimate Software for General Contractors: SwiftBidPro - Quote Faster",
    metaDescription: "SwiftBidPro is leading estimate software for general contractors. Build detailed construction bids fast with customizable templates. Try for free!",
    h1Heading: "The Best Estimate Software for General Contractors",
    introParagraph: "SwiftBidPro streamlines bidding for general contractors. From residential remodels to commercial builds, our app offers flexible templates to estimate every aspect of your project. Calculate costs for labor, materials, and subcontractors instantly, then send professional quotes from your phone — win more contracts with speed and precision.",
    tradeSpecificFeatures: [
      {
        title: "Construction Project Templates",
        description: "Versatile templates for full builds, renovations, or specific scopes, with line items for all trades and project phases."
      },
      {
        title: "Comprehensive Cost Breakdowns",
        description: "Break down costs by category — labor, materials, equipment, subs — for transparent, detailed bids clients trust."
      },
      {
        title: "Subcontractor Integration",
        description: "Incorporate subcontractor quotes into your master estimate to ensure accurate total project costs."
      },
      {
        title: "Professional Contractor Proposals",
        description: "Deliver branded, detailed proposals with online access for client review and acceptance, setting your firm apart."
      }
    ],
    primaryKeyword: "general contractor estimate software",
    secondaryKeywords: ["construction estimating software", "contractor bid software"],
    imagePath: "https://placehold.co/600x400/2563EB/FFFFFF?text=Contractor+Estimate+Software&font=Inter"
  }
];

export default tradesData;
